import { useNavigate } from "react-router-dom";
import { Home as HomeIcon, Download } from "lucide-react";
import { LOGO_URL } from "@/config";
import generatePDF from "@/utils/generatePDF";
import FinancialCharts from "@/components/analytics/FinancialCharts";

const AnalyticsPage = ({ data, user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="finance-app min-h-screen p-3 sm:p-6 lg:p-8" data-testid="analytics-page">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-4 sm:mb-8 page-header-mobile">
          <div className="flex items-center gap-2 sm:gap-4">
            <img src={LOGO_URL} alt="SubiWealth" className="h-8 sm:h-12" />
            <h1 className="page-title">Financial Analytics</h1>
          </div>
          <div className="flex items-center gap-2 sm:gap-4 header-actions">
            <button data-testid="back-to-dashboard" className="nav-btn primary" onClick={() => navigate("/")}>
              <HomeIcon size={16} className="inline mr-1" />
              Dashboard
            </button>
            <button data-testid="export-pdf-btn" className="nav-btn outline flex items-center gap-1 sm:gap-2" onClick={() => generatePDF(data, user?.name || "User")}>
              <Download size={16} />
              <span className="hidden sm:inline">Export PDF</span>
            </button>
          </div>
        </div>

        <FinancialCharts incomes={data.incomes} expenses={data.expenses} savings={data.savings} />
      </div>
    </div>
  );
};

export default AnalyticsPage;
